import {ApiException} from "scalesoft.healthplatform.webhub/Scripts/AjaxWebHubClients.generated";
import type IErrorContract from "./Error-Handler/IErrorContract";
import {CustomHeaderNames} from "./Generated/ConstantsWebHub.generated";
import Utils from "./Utils";

export const interceptFetch = (successCallback: () => void, intervalId: number | null): void => {
    window.fetch = new Proxy(window.fetch, {
        apply: async (
            target: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>,
            thisArg: unknown,
            args: [RequestInfo, RequestInit?]
        ) => {
            const requestInit = args[1];
            const requestInfo = args[0];
            const baseUrl = Utils.getBaseUrl();
            const headers = requestInit?.headers as Record<string, string> | undefined;
            try {
                const requestUrl = (requestInfo as Request).url ?? (requestInfo as string);
                const isLocalUrl = requestUrl.lastIndexOf(baseUrl, 0) === 0 ||
                    requestUrl.lastIndexOf(window.location.origin, 0) === 0;

                if (headers && headers[CustomHeaderNames.DisableLoginProlong] === "true") {
                    return await target.apply(thisArg, args);
                }

                if (isLocalUrl && intervalId !== null) { // Clear interval only when local requests are sent
                    clearInterval(intervalId);
                }

                const result = await target.apply(thisArg, args);

                if (isLocalUrl) {
                    successCallback();
                    redirectToSignoutUrlIfProvided(result);
                }

                return result;
            } catch (e) {
                if (e instanceof ApiException) {
                    throw e;
                }
                if (e instanceof Error) {
                    const errorContract = {
                        errorDescriptions: [{
                            text: e.message,
                        }],
                    } as IErrorContract;
                    const exception =  new ApiException("Failed to send request", 0, JSON.stringify(errorContract), (headers as {[key: string]: any}) ?? null, null);
                    exception.name = e.name;
                    throw exception;
                }

                throw e;
            }
        }
    });
};

const redirectToSignoutUrlIfProvided = (response: Response): void => {
    const redirectUrl = response.headers.get("X-Signout-Redirect-Url");
    if (redirectUrl) {
        window.location.replace(redirectUrl);
    }
}
